import React, { useContext } from 'react';
import styled from 'styled-components';
import { PlusCircleIcon, MinusCircleIcon, TrashIcon } from './Icon'
import { CartContext } from './contexts/CartContext';
import { convertCentsToDollar } from '../utils'
import { Notification } from 'element-react'
import ResponsiveImage from './ResponsiveImage';

import config from '../aws-exports'

const {
    aws_user_files_s3_bucket_region: region,
    aws_user_files_s3_bucket: bucket
} = config

const CartItem = ({ product }) => {
    const { increase, decrease, removeProduct } = useContext(CartContext);
    const url = `https://${bucket}.s3.${region}.amazonaws.com/public/${product.file.key}`

    const notify = (message) =>
        Notification({ title: 'success', message, type: 'success' });

    return (
        <Item>
            <Thumb alt={product.name} src={url} />

            <Info>
                <Name>{product.name}</Name>
                <Price>{convertCentsToDollar(product.price)}</Price>
            </Info>

            <Controls>
                <Qty>Qty: {product.quantity}</Qty>

                <Actions>
                    <IconBtn
                        aria-label="increase quantity"
                        onClick={() => { increase(product); notify('Added to cart!'); }}
                    >
                        <PlusCircleIcon width={'20px'} />
                    </IconBtn>

                    {product.quantity > 1 && (
                        <IconBtn
                            $danger
                            aria-label="decrease quantity"
                            onClick={() => { decrease(product); notify('Removed from cart!'); }}
                        >
                            <MinusCircleIcon width={'20px'} />
                        </IconBtn>
                    )}

                    {product.quantity === 1 && (
                        <IconBtn
                            $danger
                            aria-label="remove item"
                            onClick={() => { removeProduct(product); notify('Deleted from cart!'); }}
                        >
                            <TrashIcon width={'20px'} />
                        </IconBtn>
                    )}
                </Actions>
            </Controls>
        </Item>
    );
}

export default CartItem;

/* ---------- styles ---------- */
const Item = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr;
  grid-template-rows: auto auto;
  gap: 10px 16px;
  padding: 16px 4px;
  border-bottom: 1px solid rgba(31, 45, 61, 0.08);

  &:last-child {
    border-bottom: none;
  }

  @media screen and (min-width: 580px) {
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

const Thumb = styled(ResponsiveImage)`
  flex: 0 0 auto;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  background: #f4f6f8;
  grid-column: 1;
  grid-row: 1 / span 2;

  @media screen and (min-width: 580px) {
    grid-column: auto;
    grid-row: auto;
  }
`;

const Info = styled.div`
  flex: 1 1 150px;
  min-width: 0;
  grid-column: 2;
  grid-row: 1;

  @media screen and (min-width: 580px) {
    grid-column: auto;
    grid-row: auto;
  }
`;

const Name = styled.h5`
  margin: 0 0 4px;
  font-size: 1rem;
  font-weight: 700;
  color: #1f2d3d;
  text-transform: capitalize;
`;

const Price = styled.p`
  margin: 0;
  color: #6a7b8a;
  font-size: 0.9rem;
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  grid-column: 2;
  grid-row: 2;

  @media screen and (min-width: 580px) {
    display: contents;
  }
`;

const Qty = styled.span`
  flex: 0 0 auto;
  background: rgba(1, 191, 113, 0.1);
  color: #0a8f57;
  font-weight: 700;
  font-size: 0.82rem;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
`;

const IconBtn = styled.button`
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  background: ${({ $danger }) => ($danger ? '#ef5350' : '#01bf71')};
  transition: transform 0.12s ease, filter 0.12s ease;

  &:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }
`;
